class CountdownTimer {
  constructor(config) {
    this.timezone = config.timezone || 'UTC';
    this.isLooping = config.isLooping || false;
    this.container = document.querySelector(config.container);
    this.intervalId = null;
    
    this.init();
  }
  
  isValidTimezone(timezone) {
    try {
      Intl.DateTimeFormat(undefined, { timeZone: timezone });
      return true;
    } catch {
      return false;
    }
  }
  
  getCurrentTimeInTimezone() {
    const now = new Date();
    const timeInTimezone = new Date(now.toLocaleString("en-US", {timeZone: this.timezone}));
    return timeInTimezone;
  }
  
  getTimeUntilEndOfDay() {
    const now = new Date();
    const timeInTimezone = new Date(now.toLocaleString("en-US", {timeZone: this.timezone}));
    
    const endOfDay = new Date(timeInTimezone);
    endOfDay.setHours(23, 59, 59, 999);
    
    const timeLeft = endOfDay.getTime() - timeInTimezone.getTime();
    
    return timeLeft;
  }
  
  init() {
    if (!this.isValidTimezone(this.timezone)) {
      console.warn(`Invalid timezone: ${this.timezone}. Using UTC.`);
      this.timezone = 'UTC';
    }
    
    if (!this.container) {
      console.error('Timer container not found');
      return;
    }
    
    this.createTimerHTML();
    this.start();
  }
  
  createTimerHTML() {
    this.container.innerHTML = `
      <div class="timer-display">
        <div class="timer-unit">
          <span class="timer-value" id="hours">00</span>
          <span class="timer-label">Hours</span>
        </div>
        <div class="timer-separator">:</div>
        <div class="timer-unit">
          <span class="timer-value" id="minutes">00</span>
          <span class="timer-label">Minutes</span>
        </div>
        <div class="timer-separator">:</div>
        <div class="timer-unit">
          <span class="timer-value" id="seconds">00</span>
          <span class="timer-label">Seconds</span>
        </div>
      </div>
    `;
  }
  
  start() {
    this.updateDisplay();
    
    this.intervalId = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }
  
  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  
  reset() {
    this.stop();
    this.updateDisplay();
  }
  
  updateDisplay() {
    const timeLeft = this.getTimeUntilEndOfDay();
    
    if (timeLeft <= 0) {
      this.handleTimerComplete();
      return;
    }
    
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    this.updateTimerValue('hours', hours);
    this.updateTimerValue('minutes', minutes);
    this.updateTimerValue('seconds', seconds);
  }
  
  updateTimerValue(unit, value) {
    const element = document.getElementById(unit);
    if (element) {
      element.textContent = value.toString().padStart(2, '0');
    }
  }
  
  handleTimerComplete() {
    this.updateTimerValue('hours', 0);
    this.updateTimerValue('minutes', 0);
    this.updateTimerValue('seconds', 0);
    
    if (this.isLooping) {
      setTimeout(() => {
        this.updateDisplay();
      }, 1000);
    } else {
      this.stop();
    }
  }
  
  getTimeRemaining() {
    return this.getTimeUntilEndOfDay();
  }
}
